<template>
    <div>
        <b-modal ref="addPayment" hide-footer title="Dodaj wpłatę">
            <alert-loading v-if="paymentLoading"></alert-loading>
            <form-payment v-if="selectedInvoice && !paymentLoading" ref="addPaymentForm" :currencyName="invoiceCurrency"
                          :handleSubmit="handlePayment"
                          :values="paymentData" :errors="paymentViolations"></form-payment>
            <b-row v-if="!paymentLoading">
                <b-col>
                    <b-button class="mt-3" variant="primary" block @click="hideAddPaymentModal"><span>Anuluj</span>
                        <svg-icon name="back"/>
                    </b-button>
                </b-col>
                <b-col>
                    <b-button class="mt-3" variant="default" block @click="sendPaymentForm"><span>Zapisz</span>
                        <svg-icon name="tick"/>
                    </b-button>
                </b-col>
            </b-row>
        </b-modal>
        <b-modal ref="paymentList" hide-footer>
            <alert-loading v-if="paymentListLoading || paymentDeleteLoading || deductionListLoading"></alert-loading>
            <div v-if="!paymentListLoading && !paymentDeleteLoading && !deductionListLoading " class="table-responsive">
                <h3>Lista wpłat</h3>
                <table class="table table-striped table-bordered table-hover table-clickable table-search">
                    <thead>
                    <tr>
                        <th>Kwota</th>
                        <th>Data wpłaty</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in paymentListItems">
                        <td class="td-no_link">{{ item.amount }}</td>
                        <td class="td-no_link">{{ item.paymentDate | date }}</td>
                        <td>
                            <a href="#" class="btn btn-icon btn-icon--warning" @click.prevent="deletePayment(item)">
                                <svg-icon name="minus"/>
                            </a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="!paymentListLoading && !paymentDeleteLoading && !deductionListLoading && deductionListItems.length > 0" class="table-responsive">
                <h3>Lista potrąceń</h3>
                <table class="table table-striped table-bordered table-hover table-clickable table-search">
                    <thead>
                    <tr>
                        <th>Kwota</th>
                        <th>Data potrącenia</th>
                        <th>Opis</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in deductionListItems">
                        <td class="td-no_link">{{ item.amount }}</td>
                        <td class="td-no_link">{{ item.deductionDate | date }}</td>
                        <td class="td-no_link">{{ item.description }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <b-row v-if="!paymentListLoading && !paymentDeleteLoading">
                <b-col>
                    <b-button class="mt-3" variant="primary" block @click="hidePaymentList"><span>Zamknij</span>
                        <svg-icon name="back"/>
                    </b-button>
                </b-col>
            </b-row>
        </b-modal>
        <div v-if="createdPaymentMessage" class="alert alert-success">Płatność w kwocie {{createdPaymentMessage}} została dodana</div>
        <div v-if="deletePaymentMessage" class="alert alert-success">Płatność w kwocie {{deletePaymentMessage}} została usunięta</div>
        <alert-loading v-if="loading"></alert-loading>
        <div v-if="!loading" class="table-responsive">
            <table class="table table-striped table-bordered table-hover table-clickable table-search">
                <thead>
                <tr>
                    <th>Numer</th>
                    <th>Data wystawienia</th>
                    <th>Termin płatności</th>
                    <th>Dłużnik</th>
                    <th>Kwota</th>
                    <th>Do zapłaty</th>
                    <th>Status</th>
                    <th>Cesja</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in items">
                    <td class="td-no_link">
                        {{ item['number'] }}
                    </td>
                    <td class="td-no_link">
                        {{ item['createDate'] | date }}
                    </td>
                    <td class="td-no_link">
                        {{ item['paymentDate'] | date }}
                    </td>
                    <td class="td-no_link">
                        {{ item['debtorData']['name'] }},<br>NIP: {{ item['debtorData']['nip'] }}
                    </td>
                    <td class="td-no_link">
                        {{ item['amount'] }}
                    </td>
                    <td class="td-no_link">
                        {{ item['leftToPaid'] }}
                    </td>
                    <td class="td-no_link">
                        <span v-if="item['paid']" class="element_status closed">Zapłacona</span>
                        <span v-if="!item['paid'] && !item['deducted']" class="element_status open">Niezapłacona</span>
                        <span v-if="item['deducted']" class="element_status deducted">Potrącona</span>
                        <span v-if="item['returned']" class="element_status returned">Zwrócona</span>
                    </td>
                    <td class="td-no_link">
                        {{ item['cessionAvailable'] | translate}}
                    </td>
                    <td>
                        <a href="#" v-b-tooltip.hover.bottom title="Dodaj wpłatę"
                           class="btn btn-icon btn-icon--success" @click.prevent="addPayment(item)">
                            <svg-icon name="confirm"/>
                        </a>
                        <a href="#" v-b-tooltip.hover.bottom title="Lista wpłat"
                           class="btn btn-icon btn-icon--cancel" @click.prevent="showPaymentList(item)">
                            <svg-icon name="money"/>
                        </a>
                        <br v-if="showEditButton">
                        <a v-if="showEditButton" href="#" v-b-tooltip.hover.bottom title="Edytuj" class="btn btn-icon"
                           @click.prevent="editAction(item)">
                            <svg-icon name="edit"/>
                        </a>
                        <a v-if="showEditButton" href="#" v-b-tooltip.hover.bottom title="Usuń" @click.prevent="del(item)"
                           class="btn btn-icon btn-icon--warning">
                            <svg-icon name="minus"/>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import FormPayment from './FormPayment.vue'

  export default {
    data: function () {
      return {
        selectedInvoice: null,
        createdPaymentMessage: null,
        deletePaymentMessage: null,
        paymentData: {}
      }
    },
    components: {
      'form-payment': FormPayment
    },
    computed: {
      invoiceCurrency () {
        return this.selectedInvoice ? this.selectedInvoice.agreement.currency.name : '...'
      },
      ...mapGetters({
        error: 'agreement/invoiceList/error',
        loading: 'agreement/invoiceList/loading',
        items: 'agreement/invoiceList/items',
        factoredInvoiceDeleted: 'factoredinvoice/del/deleted',
        paymentCreated: 'payment/create/created',
        paymentViolations: 'payment/create/violations',
        paymentLoading: 'payment/create/loading',
        paymentDeleted: 'payment/del/deleted',
        paymentDeleteLoading: 'payment/del/loading',
        paymentListItems: 'factoredinvoice/paymentsList/items',
        paymentListLoading: 'factoredinvoice/paymentsList/loading',
        deductionListItems: 'factoredinvoice/deductionsList/items',
        deductionListLoading: 'factoredinvoice/deductionsList/loading',
      })
    },
    props: {
      id: {
        type: String,
        default: '',
        required: true
      },
      showEditButton: {
        type: Boolean,
        default: false
      },
      editAction: {
        type: Function,
        default () {}
      }
    },
    methods: {
      handlePayment (payment) {
        payment.factoredInvoice = this.selectedInvoice['@id']
        this.paymentData = payment
        this.$store.dispatch('payment/create/create', payment)
      },
      addPayment (invoice) {
        this.$store.dispatch('payment/create/reset')
        this.selectedInvoice = invoice
        this.paymentData = {
          amount: invoice.leftToPaid,
          paymentDate: new Date()
        }
        this.$refs.addPayment.show()
      },
      sendPaymentForm () {
        this.$refs.addPaymentForm.sendForm()
      },
      hideAddPaymentModal () {
        this.$refs.addPayment.hide()
      },
      showPaymentList (invoice) {
        this.$refs.paymentList.show()
        this.$store.dispatch('factoredinvoice/paymentsList/getItems', invoice.id)
        this.$store.dispatch('factoredinvoice/deductionsList/getItems',  invoice.id)
      },
      hidePaymentList () {
        this.$refs.paymentList.hide()
      },
      deletePayment (payment) {
        if (window.confirm('Czy na pewno chce usunąć tą płatność?')) {
          this.$store.dispatch('payment/del/delete', payment)
        }
      },
      del (item) {
        if (window.confirm('Czy na pewno chce usunąć tą fakturę?'))
          this.$store.dispatch('factoredinvoice/del/delete', item)
      },
      getInvoiceList () {
        this.$store.dispatch('agreement/invoiceList/getItems', this.id)
      },
    },
    created () {
      this.getInvoiceList()
    },
    watch: {
      factoredInvoiceDeleted: function (deleted) {
        if (deleted) {
          this.getInvoiceList()
          this.$store.dispatch('factoredinvoice/del/reset')
        }
      },

      paymentDeleted: function (deleted) {
        if (deleted) {
          this.$store.dispatch('payment/del/reset')
          this.hidePaymentList()
          this.deletePaymentMessage = deleted.amount
          setTimeout(() => {
            this.deletePaymentMessage = null
          }, 5000)
          this.getInvoiceList()
        }
      },
      paymentCreated: function (payment) {
        if (payment != null) {
          this.hideAddPaymentModal()
          this.createdPaymentMessage = payment.amount
          setTimeout(() => {
            this.createdPaymentMessage = null
          }, 5000)
          this.getInvoiceList()
        }
      }
    }
  }
</script>




// WEBPACK FOOTER //
// invoiceList.vue?50d40467